import React, { useEffect, useState } from "react";
import HeaderNav from "@/components/HeaderNav";
import Footer from "@/components/Footer";
import HeroSection from "@/components/HeroSection";
import BrandSelector from "@/components/BrandSelector";
import ModelGrid from "@/components/ModelGrid";
import PricingWizard from "@/components/PricingWizard";
import OrderBookingDrawer from "@/components/OrderBookingDrawer";
import TrustSection from "@/components/TrustSection";
import ResaleShowcase from "@/components/ResaleShowcase";
import PhysicalStoreCard from "@/components/PhysicalStoreCard";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Home() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [brand, setBrand] = useState(null);
  const [wizardProduct, setWizardProduct] = useState(null);
  const [bookingPayload, setBookingPayload] = useState(null);

  useEffect(() => {
    api
      .get("/products")
      .then(({ data }) => setProducts(data))
      .catch(() => toast.error("Failed to load models"))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-background" data-testid="home-page">
      <HeaderNav />
      <HeroSection />
      <BrandSelector selected={brand} onSelect={setBrand} availableBrands={Array.from(new Set(products.map((p) => p.brand)))} />
      <ModelGrid brand={brand} products={products} loading={loading} onPick={setWizardProduct} />
      <ResaleShowcase homepage />
      <TrustSection />
      <PhysicalStoreCard />
      <Footer />

      <PricingWizard
        open={!!wizardProduct}
        onClose={() => setWizardProduct(null)}
        product={wizardProduct}
        onBookPickup={(payload) => {
          setWizardProduct(null);
          setBookingPayload(payload);
        }}
      />
      <OrderBookingDrawer
        open={!!bookingPayload}
        onClose={() => setBookingPayload(null)}
        payload={bookingPayload}
      />
    </div>
  );
}
